import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { User } from '@sss/sdk';
import { sdk } from '../lib/sdk';
import { clearSession } from '../store/authSlice';
import VerifyEmailBanner from '../components/VerifyEmailBanner';

export default function HomePage() {
  const { t } = useTranslation();
  const [me, setMe] = useState<User | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    sdk.users.me().then(setMe).catch(() => dispatch(clearSession()));
  }, [dispatch]);

  async function onSignOut() {
    dispatch(clearSession());
    navigate('/login');
  }

  return (
    <main style={{ maxWidth: 720, margin: '4rem auto', fontFamily: 'system-ui, sans-serif', padding: '0 1rem' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <h1>Simple Secret Sharing</h1>
        <nav style={{ display: 'flex', gap: '1rem' }}>
          <Link to="/settings">{t('home.settings')}</Link>
          <button onClick={onSignOut} style={btnLink}>{t('common.signOut')}</button>
        </nav>
      </header>
      {me && <VerifyEmailBanner email={me.email} visible={!me.isEmailVerified} />}
      <p>
        {me?.email ? t('home.welcomeNamed', { name: me.email }) : t('home.welcome')}. {t('home.lead')}
      </p>
    </main>
  );
}

const btnLink: React.CSSProperties = {
  background: 'none', border: 'none', color: '#0066cc', padding: 0, cursor: 'pointer', font: 'inherit',
};
